import { Record, List } from 'immutable';

export default class GeoCodeRecord extends Record({
  id: null,
  coordinates: new List(),
  distance: null,
  name: null,
  secondaryName: undefined,
  type: null,
}) {
}
